import React from 'react'
import { images } from '../../constants'
import { motion } from 'framer-motion'

const Footer = () => {
  const textAnimate = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.4, duration: 1.5 },
    },
  }
  return (
    <motion.div
      className="container-xxl mt-5 mb-5"
      id="contacts"
      initial={'offscreen'}
      whileInView={'onscreen'}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ staggerChildren: 0.5 }}
    >
      <div className="row">
        <motion.div
          className="col-md-4 order-md-first order-last"
          variants={textAnimate}
        >
          <img
            src={images.logo}
            alt="menu"
            class="img-fluid mb-3"
            style={{
              width: '50px',
              height: 'auto',
            }}
          />
          <p style={{ marginBottom: 2 }}>
            Copyright &copy; {new Date().getFullYear()} Sushi Edge. All rights
            reserved.
          </p>
          <a
            href="https://www.yun-xu.com"
            target="_blank"
          >
            <small className="text-body-tertiary">Site by YX</small>
          </a>
        </motion.div>
        <motion.div
          className="col-md-3 order-md-1 mb-5"
          variants={textAnimate}
        >
          <h1 className="mb-3">Contact us</h1>
          <a
            href="https://www.facebook.com/p/Sushi-Edge-100066418376065/"
            target="_blank"
          >
            <i
              class="ph-fill ph-facebook-logo"
              style={{ fontSize: 30 }}
            ></i>
          </a>
        </motion.div>
        <motion.div
          className="col-md-5 order-md-2"
          variants={textAnimate}
        >
          <div className="d-flex gap-5">
            <i
              class="ph-fill ph-map-pin"
              style={{ fontSize: 40 }}
            ></i>
            <div>
              <h5>Location: </h5>
              <p>
                6B/280 Richmond Road,
                <br />
                Grey Lynn, Auckland 1021
              </p>
            </div>
          </div>
          <div className="d-flex gap-5">
            <i
              class="ph-fill ph-clock"
              style={{ fontSize: 40 }}
            ></i>
            <div>
              <h5>Hours: </h5>
              <p>Monday to Sunday 8:30am - 7:00pm</p>
            </div>
          </div>
          <div className="d-flex gap-5">
            <i
              class="ph-fill ph-user-circle"
              style={{ fontSize: 40 }}
            ></i>
            <div>
              <h5>Contacts: </h5>
              <a href="mailto:liuping6909@gmail.com">liuping6909@gmail.com</a>
              <p>09 376 6218</p>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  )
}

export default Footer
